import DateRangePicker from 'features/date-range-selection/dateRangePicker';
import { FC, Fragment } from 'react';
import { useLocation, matchPath } from 'react-router-dom';

const routesWithoutBreadcrumbBar = [
  '/marketing-mix-modelling',
  '/visitors',
  '/visitors/:visitorId',
  '/settings/webhooks',
  '/webhooks',
  '/settings/data-science/tasks',
  '/internal',
  '/settings/segmentation-config',
  '/settings/integrations/setup/google-ads',
  '/settings/integrations/setup/facebook-ads',
  '/settings/integrations/:platformCategory/:platform/:type/run'
];

const PageBreadcrumbBar: FC = () => {
  let routes: string[] = ['Dashboard'];
  const location = useLocation();
  const pathname = location?.pathname ?? '';

  routes = pathname.trimEnd().replace('/', '').replace('/$', '').split('/');

  if (pathname === '/') {
    routes = ['Dashboard'];
  }

  const shouldShowBreadcrumbBar = !routesWithoutBreadcrumbBar.some((pattern) =>
    matchPath({ path: pattern, end: true }, pathname)
  );

  const Breadcrumb: FC<string> = (route: string): any => {
    const index = routes.findIndex(
      (currentIndex: string) => currentIndex === route
    );

    return (
      <Fragment key={route}>
        <p className="pr-2 align-bottom leading-none text-primary-700 text-xl capitalize">
          {getPageLabel(route)}
        </p>
        {index !== routes.length - 1 && (
          <i className="ra-icons-generic-down-arrow -rotate-90 text-xs row flex mr-2"></i>
        )}
      </Fragment>
    );
  };

  return shouldShowBreadcrumbBar ? (
    <>
      <div className="flex items-center justify-between flex-wrap bg-neutral-100 mb-4">
        <div className="flex flex-row justify-center items-center">
          {routes.map((route: string) => Breadcrumb(route))}
        </div>
        <div className="flex-row">
          <DateRangePicker />
        </div>
      </div>
    </>
  ) : (
    <></>
  );
};

function getPageLabel(route: string) {
  if (route.startsWith('utm-')) {
    const pageNameSuffixStartingIndex = route.indexOf('-') + 1;
    const pageNameSuffix = route.substring(pageNameSuffixStartingIndex);
    return `UTM ${pageNameSuffix}`;
  }

  if (route.indexOf('-roi') > 0) {
    const pageNamePrefix = route
      .substring(0, route.indexOf('-roi'))
      .split('-')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');

    return `${pageNamePrefix} ROI`;
  }

  if (route === 'os') {
    return 'OS';
  }

  return route.replaceAll('-', ' ');
}

export default PageBreadcrumbBar;
